module.exports = __webpack_public_path__ + "fonts/Manrope-700-greek21.4f6140c.woff2";